import React from 'react';
import PropTypes from 'prop-types';
import { compose, withPropsOnChange, branch, renderComponent } from 'recompose';

import { Slider } from 'components/core/Slider';
import { FacilityImage } from 'components/facility/FacilityImage';

// Fallback component when there are no images - only passes needed props
const NoImagesFallback = ({ facility, size, onLoad }) => (
	<FacilityImage
		size={size}
		alt={`${facility?.name || 'Storage facility'} - No photos available`}
		lazyLoad={true}
		onLoad={onLoad}
	/>
);

NoImagesFallback.propTypes = {
	facility: PropTypes.object,
	size: PropTypes.string,
	onLoad: PropTypes.func,
};

export const enhance = compose(
	withPropsOnChange(['facility'], ({ facility, images, size }) => ({
		className: 'facility-image-carousel',
		children: images.map((image, index) => (
			<FacilityImage
				key={image}
				src={image}
				size={size}
				alt={`${facility.name} ${facility.location.streetAddress1} ${facility.location.city}, ${facility.location.state} - Photo ${index}`}
				lazyLoad={true}
			/>
		)),
	})),
	branch(
		({ children }) => !children || !children.length,
		renderComponent(NoImagesFallback),
	),
);

export default enhance(Slider);
